import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { NewsFeedWidget } from '@/components/dashboard';
import { useEffect } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function NewsFeed() {
    const { refreshUnreadFeedCount } = useAuth() || {};

    // Comportement iOS/Slack : à l'ouverture de la page Fil d'actualité,
    // tous les posts visibles pour cet utilisateur sont marqués comme lus.
    // La pastille du menu passe à 0 instantanément (fiabilité totale).
    useEffect(() => {
        (async () => {
            try {
                await api.post('/feed/mark-all-read');
                refreshUnreadFeedCount?.();
                if (typeof navigator !== 'undefined' && 'clearAppBadge' in navigator) {
                    try { navigator.clearAppBadge(); } catch { /* noop */ }
                }
            } catch { /* silent */ }
        })();
    }, [refreshUnreadFeedCount]);

    return (
        <DashboardLayout>
            <div className="space-y-4" data-testid="news-feed-page">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-outfit font-semibold text-slate-900">Fil d&apos;actualité</h1>
                    <p className="text-slate-500 mt-1 text-sm">Les dernières publications de Valnexo et de vos équipes.</p>
                </div>
                <NewsFeedWidget forceExpanded />
            </div>
        </DashboardLayout>
    );
}
